import { useTranslation } from "react-i18next";
import style from "./ModuleProgress.module.css";

import Icon from "@/ui/icon/Icon";

import MarkAsCompletedButton from "@/features/courses/components/markAsCompletedButton/MarkAsCompletedButton";
import CertificateLink from "@/features/certificates/components/certificateLink/CertificateLink";

import { COMPLETE_COURSE_THRESHOLD } from "@/utils/constants";
import { useGetCourseCertificate } from "@/features/certificates/hooks/useGetCourseCertificate";
import { useCourseCompletionContext } from "@/features/courses/hooks/useCourseCompletion";
import { useLocalized } from "@/i18n/useLocalized";

function ModuleProgress({ course, coursePercentComplete }) {
	const { t } = useTranslation();
	const l = useLocalized();
	const { certificate } = useGetCourseCertificate(course?.slug, {
		enabled: course?.is_completed === true,
	});
	const { setShowCertificateToast } = useCourseCompletionContext();

	return (
		<div className={style.progressHolder}>
			<div className={style.title}>{l(course, "name")}</div>
			<div className={style.body}>
				<div className={style.bar}>
					<div>
						{t("courses:progress.complete", {
							percent: coursePercentComplete,
						})}
					</div>
					<div className={style.ratio}>
						<span>{course.completed_units}</span>
						<Icon icon="fa-slash-forward" />
						<span>{course.total_units}</span>
					</div>
				</div>
				<div className={style.progress}>
					<div
						className={style.fill}
						style={{
							"--progress-percent": `${coursePercentComplete}%`,
						}}
					></div>
				</div>
			</div>
			{coursePercentComplete >= COMPLETE_COURSE_THRESHOLD &&
				coursePercentComplete != 100 &&
				!course?.is_completed && (
					<MarkAsCompletedButton
						course={course}
						setShowCertificateToast={setShowCertificateToast}
					/>
				)}
			{certificate?.certificate_id &&
				certificate?.is_unlocked &&
				certificate?.image_png && (
					<CertificateLink
						certificateID={certificate.certificate_id}
					/>
				)}
		</div>
	);
}

export default ModuleProgress;
